/* hs-eslint ignored failing-rules */
/* eslint-disable react/prop-types */

import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// @ts-expect-error module not typed
import { ThreadViewStoreSingleton } from '../../ThreadViewStoreSingleton';
import ThreadViewManager from './ThreadViewTrackingManager';
// @ts-expect-error module not typed
import { DeletedMessagesContext } from '../../thread-deletion/context/DeletedMessagesContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const authPropDefault = {};
const ThreadlessThreadViewWrapper = ({
  auth = authPropDefault,
  beaconTracker,
  children,
  omnibusData,
  tracker
}) => {
  // initialize store singleton if it hasn't been
  useEffect(() => {
    ThreadViewStoreSingleton.init({
      auth,
      threadId: null,
      omnibusData
    });
  }, [auth, omnibusData]);

  // delay mounting by one cycle to give the manager
  // a chance to sync state
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const threadViewManagerProps = {
    beaconTracker,
    tracker
  };
  // Render the thread view manager to interact with the
  // inner store (if it's in use) without overwriting the
  // children's redux context. Until everything is migrated,
  // we also need to run the same behavior on the app-hosted
  // store as well
  return /*#__PURE__*/_jsxs(DeletedMessagesContext.Provider, {
    value: {
      showDeletedMessages: false
    },
    children: [/*#__PURE__*/_jsx(ThreadViewManager, Object.assign({}, threadViewManagerProps)), mounted ? children : null]
  });
};
ThreadlessThreadViewWrapper.displayName = 'ThreadlessThreadViewWrapper';
ThreadlessThreadViewWrapper.propTypes = {
  auth: PropTypes.object.isRequired,
  beaconTracker: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  tracker: PropTypes.object.isRequired
};
export default ThreadlessThreadViewWrapper;